import {
    addToChainAfter,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadRecentlyViewed,
    LoadRecommendedProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { CustomNewProductsState } from "@midland-industries/Store/Data/NewProducts/NewProductsReducer";

type LoadCarouselProductsProps = Parameters<typeof LoadRecentlyViewed>[0];

function LoadNewProductsForCarousel(props: LoadCarouselProductsProps) {
    if (props.parameter.carouselType !== "newProducts") {
        return;
    }

    const state = props.getState() as CustomNewProductsState;

    const index = state.xcentiumNewProducts.requestCache.findIndex(
        rc =>
            rc.params.returnCategories === false &&
            rc.params.returnProductDtos === true &&
            rc.params.categoryId === undefined &&
            rc.params.pageSize === props.parameter.numberOfProductsToDisplay,
    );

    if (index === -1) {
        return;
    }

    const productIds = state.xcentiumNewProducts.requestCache[index].results.newProductDtos.map(p => p.id);

    props.getProductCollectionParameter = { productIds };
}

addToChainAfter(chain, LoadRecommendedProducts, LoadNewProductsForCarousel);
